import type User from '@this/domain/user/user';

export const setupBugsnag = (user: User) => {
  if (typeof bugsnagClient === 'undefined') {
    return;
  }

  bugsnagClient.user = {
    id: user.id,
    name: user.name,
    email: user.email
  };
};

export const reportError = (e: unknown) => {
  if (typeof bugsnagClient === 'undefined') {
    return;
  }

  if (e instanceof Error) {
    bugsnagClient.notify(e);
    return;
  }

  let errorObj: Error;
  let metaData: Record<string, unknown> = {};

  if (e !== null && typeof e === 'object') {
    errorObj = new Error('Non-Error object was thrown');
    metaData = {
      originalErrorType: 'object',
      originalErrorValue: e
    };
  } else if (typeof e === 'string') {
    errorObj = new Error(e);
    metaData = {
      originalErrorType: 'string'
    };
  } else {
    errorObj = new Error(`Non-Error value was thrown: ${String(e)}`);
    metaData = {
      originalErrorType: typeof e,
      originalErrorValue: e
    };
  }

  bugsnagClient.notify(errorObj, {
    metaData: {
      originalError: metaData
    },
    severity: 'error'
  });
};
